import { render, staticRenderFns } from "./customer-type.vue?vue&type=template&id=4dc49a94"
import script from "./customer-type.vue?vue&type=script&lang=js"
export * from "./customer-type.vue?vue&type=script&lang=js"
import style0 from "./customer-type.vue?vue&type=style&index=0&id=4dc49a94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports